export const isUseServiceSite = () => {
  /**
   * 外部サービスサイトを利用するかどうか
   * true: 外部サービスサイトを利用する
   * false: 外部サービスサイトを利用しない
   */
  return process.env.REACT_APP_USE_SERVICE_SITE === 'true';
};
